export default "__VITE_ASSET__DeTOoHLS__"